var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"management-page",class:{ hideSidebar: _vm.isCollapse, openSidebar: !_vm.isCollapse }},[_c('div',{staticClass:"main-container"},[_c('sidebar',{staticClass:"sidebar-container",attrs:{"isCollapse":_vm.isCollapse}}),_c('app-main')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }